import { render, staticRenderFns } from "./PackagesListingItem.vue?vue&type=template&id=1f112f7a&scoped=true"
import script from "./PackagesListingItem.vue?vue&type=script&lang=js"
export * from "./PackagesListingItem.vue?vue&type=script&lang=js"
import style0 from "./PackagesListingItem.vue?vue&type=style&index=0&id=1f112f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f112f7a",
  null
  
)

export default component.exports